/**
 * Le contexte d'une ligne DÉJÀ refusée, en lecture seule, pour l'écran
 * « À valider » : le motif précédent du valideur et la réponse qui lui a été
 * faite — ou l'absence explicite de réponse.
 *
 * POURQUOI les deux ensemble, et pourquoi « Aucune réponse apportée » s'écrit
 * au lieu de ne rien afficher : le motif de refus est souvent une QUESTION, et
 * le valideur doit revoir sa question et la réponse EN FACE avant de statuer
 * une seconde fois. Un bloc vide se lirait « il n'y a jamais eu de refus », ce
 * qui est le contraire de ce qu'il faut savoir.
 *
 * Partagé entre la section des factures et celle des avoirs du même écran : les
 * deux affichent la même chose, et un seul composant garantit qu'elles
 * continueront de le faire.
 */
export function MotifEtReponse({
  motif,
  reponse,
}: {
  motif: string;
  reponse?: string | null;
}) {
  return (
    <div className="mt-1 rounded bg-amber-50 ring-1 ring-inset ring-amber-100 px-2 py-1.5 font-normal">
      <div className="text-xs text-amber-900">⨯ Refus précédent : {motif}</div>
      <div className="text-xs text-slate-700 mt-0.5">
        {reponse ? (
          <>↩ Réponse : {reponse}</>
        ) : (
          <span className="italic text-slate-500">↩ Aucune réponse apportée</span>
        )}
      </div>
    </div>
  );
}
